import React from 'react';
import {
  Divider,
  Col,
  Stack,
  FlexboxGrid,
  Form,
  InputNumber,
  SelectPicker,
  InputPicker,
  IconButton,
  Tooltip,
  Whisper,
  Input
} from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';
import ExpandOutlineIcon from '@rsuite/icons/ExpandOutline';
const ProductionDetails = ({
  data5,
  addMaterial,
  compdata,
  siii,
  finishdata,
  materialdata,
  handleProductionDetailChange,
  fetchFinishes,
  setFinishData,
  isLoadingfin,
  setIsLoadingfin,
  deleteMaterial,
  label
}) => {
  const getUnitValue = (unit) => {
    if (!unit) return "Inch"; // default

    const clean = unit.trim().toLowerCase();

    const found = siii.find(
      u => u.label.toLowerCase() === clean || u.value.toLowerCase() === clean
    );

    return found ? found.label : "Inch";
  };

  return (
    <div>
      <Divider>
        <b>Production Details</b>
      </Divider>
      <Stack justifyContent="flex-end">
        <Whisper placement="auto" trigger="hover" speaker={<Tooltip>Add Material</Tooltip>}>
          <IconButton icon={<ExpandOutlineIcon />} onClick={addMaterial} active />
        </Whisper>
      </Stack>
      <Form>
        <FlexboxGrid justify="space-around" style={{ marginBottom: '10px' }}>
          {data5.ProductionDetail.map((prodct, index) => (
            <div key={index}>
              <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                <Form.ControlLabel> {label[0]?.attributes?.MaterialName}</Form.ControlLabel>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <InputPicker
                    data={materialdata}
                    name={`MaterialNm_${index}`}
                    value={prodct.MaterialNm}
                    container={() => document.getElementById('custom-container')}
                    cleanable={false}
                    placement="auto"
                    labelKey="label"
                    valueKey="label"
                    onSelect={(value, item) => {
                      // Save both MaterialCode and MaterialName
                      handleProductionDetailChange(index, 'MaterialNm', item.label); // Save MaterialName
                      handleProductionDetailChange(index, 'MaterialCode', item.value); // Save MaterialCode
                    }}
                    onChange={value => {
                      // Optionally handle changes if needed
                      if (!value) {
                        handleProductionDetailChange(index, 'MaterialNm', ''); // Clear MaterialName
                        handleProductionDetailChange(index, 'MaterialCode', ''); // Clear MaterialCode
                      }
                    }}
                  />
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                <Form.ControlLabel>{label[0]?.attributes?.Component}</Form.ControlLabel>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <InputPicker
                    data={compdata}
                    name={`Component_${index}`}
                    value={prodct.Component}
                    cleanable={false}
                    placement="auto"
                    container={() => document.getElementById('custom-container')}
                    onChange={value => handleProductionDetailChange(index, 'Component', value)}
                  />
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                <Form.ControlLabel> {label[0]?.attributes?.Sizeunit}</Form.ControlLabel>
                <div id={`custom-container-${index}`} style={{ position: "relative" }}>
                  <InputPicker
                    data={siii}
                    name={`Unit_${index}`}
                    placement="auto"
                    value={getUnitValue(prodct.Unit)}
                    cleanable={false}
                    labelKey="label"
                    valueKey="label"
                    onChange={value => handleProductionDetailChange(index, "Unit", value)}
                    container={() => document.getElementById(`custom-container-${index}`)}
                  />
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Form.ControlLabel>{label[0]?.attributes?.length}</Form.ControlLabel>
                <InputNumber
                  step={null}
                  name={`Length_${index}`}
                  value={prodct.Length || 0}
                  onChange={value => handleProductionDetailChange(index, 'Length', value)}
                  min={0}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Form.ControlLabel>{label[0]?.attributes?.width}</Form.ControlLabel>
                <InputNumber
                  step={null}
                  name={`Width_${index}`}
                  value={prodct.Width || 0}
                  onChange={value => handleProductionDetailChange(index, 'Width', value)}
                  min={0}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Form.ControlLabel>{label[0]?.attributes?.height}</Form.ControlLabel>
                <InputNumber
                  step={null}
                  name={`Height_${index}`}
                  value={prodct.Height || 0}
                  onChange={value => handleProductionDetailChange(index, 'Height', value)}
                  min={0}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Form.ControlLabel>Depth</Form.ControlLabel>
                <InputNumber
                  step={null}
                  name={`Depth_${index}`}
                  value={prodct.Depth || 0}
                  onChange={value => handleProductionDetailChange(index, 'Depth', value)}
                  min={0}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Form.ControlLabel> {label[0]?.attributes?.NetWgt}(Kg)</Form.ControlLabel>
                <InputNumber
                  step={null}
                  name={`Perpc_${index}`}
                  value={prodct.MatNetWeight || 0}
                  onChange={value => handleProductionDetailChange(index, 'MatNetWeight', value)}
                  min={0}
                />
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                <Form.ControlLabel> {label[0]?.attributes?.finish}</Form.ControlLabel>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <SelectPicker
                    id="FinishName"
                    name="FinishName"
                    value={prodct.MaterialFinishNm}
                    onSelect={(value, item) => {
                      // Save both MaterialCode and MaterialName
                      handleProductionDetailChange(index, 'MaterialFinishNm', item.label); // Save MaterialName
                      handleProductionDetailChange(index, 'MaterialFinishCode', item.value); // Save MaterialCode
                    }}
                    onChange={value => {
                      // Optionally handle changes if needed
                      if (!value) {
                        handleProductionDetailChange(index, 'MaterialFinishNm', ''); // Clear MaterialName
                        handleProductionDetailChange(index, 'MaterialFinishCode', ''); // Clear MaterialCode
                      }
                    }}
                    data={finishdata}
                    placeholder="Select"
                    labelKey="label"
                    valueKey="label"
                    block
                    container={() => document.getElementById('custom-container')}
                    menuMaxHeight={180}
                    // readOnly={!selectedMat}
                    onOpen={() => fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin)}
                    placement="auto"
                  />
                </div>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Form.ControlLabel>{label[0]?.attributes?.Qty}</Form.ControlLabel>
                <InputNumber
                  step={null}
                  name={`Qty_${index}`}
                  value={prodct.Qty || 0}
                  onChange={value => handleProductionDetailChange(index, 'Qty', value)}
                  min={0}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                <Form.ControlLabel>Remark</Form.ControlLabel>
                <Input
                  name={`Remark_${index}`}
                  value={prodct.Remark || ''}
                  onChange={value => handleProductionDetailChange(index, 'Remark', value)}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                {index > 0 && (
                  <IconButton
                    active
                    style={{ marginTop: '20px' }}
                    onClick={() => deleteMaterial(index)}
                    icon={<TrashIcon />}
                  />
                )}
              </FlexboxGrid.Item>
            </div>
          ))}
        </FlexboxGrid>
      </Form>
    </div>
  );
};

export default ProductionDetails;
